import documentationHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/documentation-header.png';
import documentationSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/documentation-section1.png';
import documentationSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/documentation-section2.png';
import documentationSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/documentation-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_DOCUMENTATION: PageblockData = {
  headerData: {
    headerText: 'Document your Salesforce org in real-time effortlessly',
    subHeaderText:
      'Create up-to-date, AI-powered documentation with clear metadata descriptions and comprehensive dependency mapping for seamless org management.',
    imgSrc: documentationHeader,
    imgAlt: 'Documentation header',
    name: 'Documentation',
  },
  pageTitle: 'Optimize Salesforce management with AI-powered documentation',
  section1: {
    imgSrc: documentationSection1,
    imgAlt: 'Documentation section img',
    title: 'Real-time documentation of your Salesforce org',
    content:
      'Automatically generate up-to-date documentation of your Salesforce environment, ensuring accurate and current records of your configurations.',
  },
  section2: {
    imgSrc: documentationSection2,
    imgAlt: 'Documentation section 2 img',
    title: 'AI-generated descriptions of your metadata',
    content:
      'Leverage AI to create clear and comprehensive descriptions for all metadata components, enhancing understanding and management of your Salesforce setup.',
  },
  section3: {
    imgSrc: documentationSection3,
    imgAlt: 'Documentation section 3 img',
    title: 'Org-wide dependency mapping',
    content:
      'Visualize and analyze dependencies across your entire Salesforce org to better understand relationships and impacts within your configurations.',
  },
};
